/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect, useReducer } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';

import PanelHeader from '../common/cards/PanelHeader';
import Card from '../common/cards/ClientPanelCard';
import clientIcon from '../../images/icons/client.svg';
import addressesIcon from '../../images/icons/addresses.svg';
import assignmentsIcon from '../../images/icons/icon-assignments.svg';
import underwritingIcon from '../../images/icons/icon-underwriting.svg';
import contactIcon from '../../images/icons/contact.svg';
import ClientPanelCardHeader from '../common/cards/ClientPanelCardHeader';
import CollapseDispatch from '../../contexts/collapseDispatch';
import collapseReducer from '../../reducers/collapse.reducer';
import ShowAll from '../common/cards/ClientPanelShowAll';
import normalizeClientPanel from '../../helpers/client.panel';

import style from './ClientPanel.module.css';

const ClientPanel = React.memo(({ clientId }) => {
  const [state, dispatch] = useReducer(collapseReducer, {
    contacts: false,
    contactsAll: false,
    addresses: false,
    addressesAll: false,
    assignments: false,
    underwriting: false,
  });

  const [clientDetails, setClientDetails] = useState({
    client: {
      available: true,
      data: [],
    },
    contacts: {
      available: true,
      data: [],
    },
    addresses: {
      available: true,
      data: [],
    },
    assignments: {
      available: true,
      data: [],
    },
    underwriting: {
      available: true,
      data: [],
    },
  });

  useEffect(() => {
    const handleSuccess = ({ data }) => {
      setClientDetails(normalizeClientPanel(data));
    };

    axios
      .get(`${process.env.REACT_APP_BASE_URL}panels/customer/${clientId}`)
      .then(handleSuccess);
  }, [clientId]);

  const getCard = (item, available, first) => {
    return <Card data={item} available={available} first={first} />;
  };

  const {
    client,
    contacts,
    addresses,
    assignments,
    underwriting,
  } = clientDetails;

  const getCardHeader = (title, collaspsed, forCard, icon) => {
    return (
      <ClientPanelCardHeader
        title={title}
        collapsed={collaspsed}
        forCard={forCard}
        img={icon}
      />
    );
  };

  const getShowAll = (title, forCard) => {
    return <ShowAll title={title} forCard={forCard} />;
  };

  return (
    <CollapseDispatch.Provider value={dispatch}>
      <section className={style.main}>
        <PanelHeader icon={clientIcon} title="CLIENT" />
        {getCard(client.data, client.available, true)}

        {getCardHeader(
          `Contacts ${
            contacts.data.length > 1 ? `(${contacts.data.length})` : ''
          }`,
          state.contacts,
          'contacts',
          contactIcon,
        )}
        {!state.contacts &&
          contacts.data.map((item, idx) => (
            <React.Fragment key={idx}>
              {state.contactsAll &&
                getCard(item, contacts.available, idx === 0)}
              {!state.contactsAll &&
                idx === 0 &&
                getCard(item, contacts.available, true)}
            </React.Fragment>
          ))}
        {!state.contacts && contacts.data.length > 1
          ? getShowAll(
              state.contactsAll ? 'View Less Contacts' : 'View All Contacts',
              'contacts',
            )
          : null}

        {getCardHeader(
          `Addresses  ${
            addresses.data.length > 1 ? `(${addresses.data.length})` : ''
          }`,
          state.addresses,
          'addresses',
          addressesIcon,
        )}
        {!state.addresses &&
          addresses.data.map((item, idx) => (
            <React.Fragment key={addresses.data.length + idx}>
              {state.addressesAll &&
                getCard(item, addresses.available, idx === 0)}
              {!state.addressesAll &&
                idx === 0 &&
                getCard(item, addresses.available, true)}
            </React.Fragment>
          ))}
        {!state.addresses && addresses.data.length > 1
          ? getShowAll(
              state.addressesAll ? 'View Less Addresses' : 'View All Addresses',
              'addresses',
            )
          : null}

        {getCardHeader(
          'Assignments',
          state.assignments,
          'assignments',
          assignmentsIcon,
        )}
        {!state.assignments &&
          getCard(assignments.data, assignments.available, true)}

        {getCardHeader(
          'Underwriting',
          state.underwriting,
          'underwriting',
          underwritingIcon,
        )}
        {!state.underwriting &&
          getCard(underwriting.data, underwriting.available, true)}
      </section>
    </CollapseDispatch.Provider>
  );
});

ClientPanel.propTypes = {
  clientId: PropTypes.string.isRequired,
};

export default ClientPanel;
